import { DoorOpen, Timer } from 'lucide-react'
import { AttendanceSpaceFields } from '@/components/features/attendance/AttendanceSpaceFields'
import {
  attendanceFieldErrors,
  defaultAttendanceConfig,
  mergeAttendanceConfig,
  toAttendanceInput,
  validateAttendanceConfig
} from '@/components/features/attendance/attendanceUtils'
import { AttendanceRetentionConfirm } from '@/components/features/spaces/retention'
import { retentionChanges } from '@/components/features/spaces/retentionUtils'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const AttendancePage = lazyPage(() => import('@/pages/Attendance'), 'AttendancePage')

export const attendanceModule: ModuleDefinition = {
  key: 'attendance',
  icon: DoorOpen,
  iconName: 'door-open',
  namespaces: ['attendance'],
  ready: true,
  ListPage: AttendancePage,
  /* Short setup on the details step (F-78 section 6.2), stored in `Space.moduleConfig.attendance`. */
  setup: {
    wizardStep: 'details',
    defaultConfig: () => defaultAttendanceConfig(),
    validate: (config, t) => validateAttendanceConfig(config, t),
    errorsFromApi: (err) => {
      const fields = attendanceFieldErrors(err)
      return Object.values(fields).some(Boolean) ? fields : null
    },
    Fields: AttendanceSpaceFields,
    /* F-203a: a new retention period is confirmed with what it would anonymize today. */
    confirmSave: {
      needed: (config, space) => retentionChanges('attendance', config, space),
      Dialog: AttendanceRetentionConfirm
    },
    persist: {
      type: 'moduleConfig',
      /* What this screen owns replaces its keys; retention and kiosk settings go back untouched. */
      toModuleConfig: (config, stored) => ({
        ...(stored || {}),
        attendance: { ...(stored?.attendance || {}), ...toAttendanceInput(config) }
      }),
      fromSpace: (space) => mergeAttendanceConfig(space.moduleConfig?.attendance)
    }
  },
  workflow: { trigger: { block: 'attendance', icon: Timer, families: ['attendance'] } }
}
